<template>
  <div>
    <v-alert type="info" text>
      Die gemeldeten Änderungswünsche der Schüler:innen können hier überprüft
      und abgebearbeitet werden. Sie sind auch den jeweiligen Kontakt-Seite der
      Person verfügbar.
    </v-alert>
    <v-card>
      <v-toolbar flat>
        <v-switch
          inset
          v-model="filter.showAll"
          label="auch bearbeitete Einträge anzeigen"
          hideDetails
        />
      </v-toolbar>
      <v-divider />
      <PersonalTable
        :items="itemsSearched"
        :loading="loading"
        @updated="fetchData"
      ></PersonalTable>
    </v-card>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { searchPerson } from "common/utils/people.js";
import PersonalTable from "./PersonalTable.vue";
export default defineComponent({
  name: "OnBoardingPersonal",
  props: ["search"],
  components: { PersonalTable },
  data() {
    return {
      loading: false,
      items: [],
      filter: {
        showAll: false,
      },
    };
  },
  computed: {
    itemsSearched() {
      if (!this.search) {
        return this.itemsFiltered;
      }
      return this.itemsFiltered?.filter(
        (el) =>
          searchPerson(el.person, this.search) ||
          searchPerson(el.creator, this.search) ||
          searchPerson(el.evaluator, this.search) ||
          el.name === this.search ||
          el.description?.toLowerCase().includes(this.search?.toLowerCase())
      );
    },
    itemsFiltered() {
      return this.items?.filter((el) =>
        this.filter.showAll ? true : !el.evaluationDate
      );
    },
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.items = (
        await this.apiList({
          resource: "checkin/person",
        })
      ).map((el) => ({
        ...el,
        creationTimestamp: el.creationDate + " " + el.creationTime,
        evaluationTimestamp: el.evaluationDate + " " + el.evaluationTime,
      }));
      this.loading = false;
    },
  },
  async created() {
    this.fetchData();
  },
});
</script>
